import { render, staticRenderFns } from "./DetailTukarVoucher.vue?vue&type=template&id=7b1011b8&scoped=true"
import script from "./DetailTukarVoucher.vue?vue&type=script&lang=js"
export * from "./DetailTukarVoucher.vue?vue&type=script&lang=js"
import style0 from "./DetailTukarVoucher.vue?vue&type=style&index=0&id=7b1011b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1011b8",
  null
  
)

export default component.exports